import React, { useId } from "react";

interface HeroQuoteOpenProps {
  className?: string;
}

const HeroQuoteOpen: React.FC<HeroQuoteOpenProps> = ({ className = "fill-SP2" }) => {
  const titleId = useId();

  return (
    <svg
      width="43"
      height="27"
      viewBox="0 0 43 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${className && className}`}
      aria-labelledby={titleId}
    >
      <title id={titleId}>Opening quotation mark</title>
      <path d="M40 0H32L26.6667 10.6667V26.6667H42.6667V10.6667H34.6667L40 0ZM13.3334 0H5.3334L0 10.6667V26.6667H16V10.6667H8L13.3334 0Z" />
    </svg>
  );
};

export default HeroQuoteOpen;
